<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"
                    ><span class="sr_only"></span
                ></a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.APPROVAL.HISTORY.POPUP.TITLE') }}</i>
                    </dt>
                    <dd>
                        <table class="create_table btmLine mt-20">
                            <colgroup>
                                <col width="154px" />
                                <col class="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}</th>
                                    <td>
                                        {{ approvalSubject | decodeXSS }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>History</th>
                                    <td class="in_gird_table">
                                        <!-- 그리드 5개줄만나오고 내부스크롤 되어야 함 -->
                                        <table class="scroll_table sm_grid">
                                            <!-- 200422수정 -->
                                            <colgroup>
                                                <col width="35px" />
                                                <col width="*" />
                                                <col width="120px" />
                                                <col width="100px" />
                                                <col width="100px" />
                                                <col width="80px" />
                                                <col width="100px" />
                                            </colgroup>
                                            <thead class="text_center">
                                                <tr>
                                                    <th colspan="3">{{ $t('FIELD.APPROVAL.PERSON.CHARGE') }}</th>
                                                    <th>{{ $t('FIELD.APPROVAL.TITLE') }}</th>
                                                    <th>{{ $t('FIELD.USER.TEAM') }}</th>
                                                    <th>{{ $t('BUTTON.FAST.DATE') }}</th>
                                                    <th>{{ $t('TITLE.GLOBAL.APPROVAL') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text_center scroll height_185">
                                                <tr v-for="(item,index) in approvalPath" :key="index">
                                                    <td class="ellipsis">
                                                        {{ index }}
                                                    </td>
                                                    <td class="text_left ellipsis">
                                                        {{ getRoleNm(item.APLN_ROLE) }}
                                                    </td>
                                                    <td class="text_left ellipsis" :title="item.NAME">
                                                        {{ item.NAME }}
                                                    </td>
                                                    <td class="ellipsis" :title="item.JOB_POSITION">
                                                        {{ item.JOB_POSITION }}
                                                    </td>
                                                    <td class="ellipsis" :title="item.DEPARTMENT_NAME">
                                                        {{ item.DEPARTMENT_NAME }}
                                                    </td>
                                                    <td class="ellipsis">
                                                        {{ getActPrssDt(item.ACT_PRSS_DT) }}
                                                    </td>
                                                    <td class="ellipsis" :title="item.STATUS">
                                                        {{ item.STATUS }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.APPROVAL.POPUP.APPROVEOPTION') }}</th>
                                    <td>
                                        {{ approvalOption }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import $ from 'jquery';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
    name: 'ApprovalHistoryPopup',
    props: {
        approvalId: '',
    },
    data() {
        return {
            approvalSubject: '',
            approvalOption: '',
            approvalPath: [],
        };
    },
    mounted() {
        this.onSearch();
    },
    methods: {
        async onSearch() {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/approval/handleSelectHistory.skp`,
                    qs.stringify({
                        approvalId: this.approvalId,
                    }),
                )
                .then(resp => {
                    Vue.$log.info('▶ ApprovalHistoryPopup.vue resp', resp);
                    if (SDLUtil.isNull(resp.data.result.rowData)) {
                        SDLUtil.alert('There is no approval information.');
                        this.$emit('close');
                    } else {
                        this.approvalSubject = resp.data.result.rowData[0].APLN_SUBJECT;
                        this.approvalOption = resp.data.result.rowData[0].APLN_CONTENTS;
                        this.approvalPath = resp.data.resultPath.rowData;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        getRoleNm(v) {
            let result = '';
            if ('0' === v) {
                result = 'Register';
            } else if ('1' === v) {
                result = 'Approval';
            } else if ('2' === v) {
                result = 'Consent';
            } else if ('9' === v) {
                result = 'Notification';
            }else if ('4' === v) {
                result = 'Parallel Consent';
            }else if ('7' === v) {
                result = 'Parallel Approval';
            } else {
                result = v;
            }
            return result;
        },
        getActPrssDt(v) {
            let result = '';
            if (!SDLUtil.isNull(v)) {
                result = v.substring(4, 6) + '.' + v.substring(6, 8) + '.' + v.substring(0, 4);
            }

            return result;
        },
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/common/popup/ApprovalHistoryPopup.vue